import React from "react";
import { Crown } from "lucide-react";

/** Small badge to show that the profile owner has an active Premium subscription. */
const PremiumBadge = ({ size = "sm" }) => {
  const sz = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-[10px]";
  const ic = size === "lg" ? "w-4 h-4" : "w-3 h-3";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r from-[#C5A880]/20 to-[#9C7B4A]/20 border border-[#C5A880] text-[#C5A880] uppercase tracking-wider ${sz}`}
      data-testid="premium-badge" title="Subscritor Premium">
      <Crown className={ic} /> Premium
    </span>
  );
};

export default PremiumBadge;
